import { Box, Flex, Text } from '@chakra-ui/layout';
import ActivityIndicator from 'components/ActivityIndicator';
import { ACTIVITIES } from 'types';

const Label = ({ text, type, color }: { text: string; type?: ACTIVITIES; color?: string }) => (
    <Flex alignItems="center">
        <ActivityIndicator type={type} color={color} />
        <Text fontSize="sm" ml="8px" fontWeight="500" color="gray.500">
            {text}
        </Text>
    </Flex>
);

export default Label;
